"use client";

import { Typography, Box } from "@mui/material";
import Link from "next/link";

export default function AttributionFooter() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "3rem",
        backgroundColor: "#000000",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Content */}
      <Box
        sx={{
          textAlign: "center",
          zIndex: 20,
          color: "rgba(255, 255, 255, 0.6)",
          fontWeight: 300,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexWrap: "wrap",
          gap: "0.5rem",
          fontSize: { xs: "0.75rem", sm: "0.875rem" },
        }}
      >
        <Link
          href="https://pi-que.com"
          target="_blank"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <Typography
            component="span"
            sx={{
              color: "inherit",
              fontSize: "inherit",
              "&:hover .company-name": {
                color: "#8ccac7",
              },
              transition: "color 300ms",
            }}
          >
            public interest engineering by{" "}
            <Box
              component="span"
              className="company-name"
              sx={{
                transition: "color 300ms",
                fontWeight: 400,
              }}
            >
              pi.que llc
            </Box>{" "}
            © 2024 - {new Date().getFullYear()}. all rights reserved.
          </Typography>
        </Link>
      </Box>

      {/* Subtle Geometric Background */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          zIndex: 0,
        }}
      >
        {/* Circle 1 */}
        <Box
          sx={{
            position: "absolute",
            width: "5rem",
            height: "5rem",
            borderRadius: "50%",
            backgroundColor: "text.primary",
            opacity: 0.1,
            left: "25%",
            bottom: 0,
          }}
        />
        {/* Circle 2 */}
        <Box
          sx={{
            position: "absolute",
            width: "4rem",
            height: "4rem",
            borderRadius: "50%",
            backgroundColor: "text.primary",
            opacity: 0.1,
            left: "75%",
            bottom: 0,
          }}
        />
      </Box>
    </Box>
  );
}
